import { render, staticRenderFns } from "./FooterCard.vue?vue&type=template&id=7ae8d0a8"
import script from "./FooterCard.vue?vue&type=script&lang=js"
export * from "./FooterCard.vue?vue&type=script&lang=js"
import style0 from "./FooterCard.vue?vue&type=style&index=0&id=7ae8d0a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports